// extracted by css-extract-rspack-plugin
export default {"backLink":"LQc4P","docsIframe":"PkJ4f","codeSnippetCopyButton":"TRVoI","codeSnippet":"XJ2JQ"};